// extracted by mini-css-extract-plugin
export var legendIndicator = "_b0-1";
export var legendRight = "_b0-0";